/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { THERMAL_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { HandoffPage } from "@/features/processing/components/handoff-page";

export const Route = createFileRoute("/_app/processing/thermal/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(THERMAL_FORM))
      throw redirect({ to: "/processing/thermal" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <HandoffPage
      form="thermal"
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
